import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { customerName, useCustomer } from '@/features/customers';

function Named({ storeId, customerId }: { storeId: string; customerId: string }) {
  const { t } = useTranslation('giftCards');
  const { data } = useCustomer(storeId, customerId);
  return (
    <Link
      to="/s/$storeId/customers/$customerId"
      params={{ storeId, customerId }}
      className="hover:underline"
      onClick={(e) => e.stopPropagation()}
    >
      {data ? (customerName(data) ?? data.email) : t('customer.view')}
    </Link>
  );
}

/** Gift cards carry the customer id only; the name is read from the (cached) customer. */
export function CustomerLink({
  storeId,
  customerId,
}: {
  storeId: string;
  customerId: string | null;
}) {
  const { t } = useTranslation('giftCards');
  const { can } = usePermissions();
  if (!customerId) return <span className="text-muted-foreground">{t('customer.none')}</span>;
  if (!can('customers.read')) return <span>{t('customer.linked')}</span>;
  return <Named storeId={storeId} customerId={customerId} />;
}
